import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { closeSearchOverlay } from "./helpers"

import "./styles/index.css"


if (!jQuery) {
    var script = document.createElement('script')
    script.src = 'https://code.jquery.com/jquery-3.7.1.js'
    script.integrity = 'sha256-eKhayi8LEQwp4NKxN+CfCh+3qOVUtJn3QNZ0TciWLP4='
    script.crossOrigin = 'anonymous'
    script.onload = function () {
        jQuery = window.jQuery.noConflict(true)
    }
    document.getElementsByTagName('head')[0].appendChild(script)
}

document.head.innerHTML += '<link rel="stylesheet" href="https://nosto-campaign-assets.s3.amazonaws.com/shopify-1582548/swatches.css" type="text/css"/>';

export const collectionHeader = document.querySelector('.collection-hero--no-image')?.closest('.shopify-section') || null;

const inputCssSelector = window.outerWidth < 990 ? '#mobile-search-Search-In-Template' : '#desktop-search-Search-In-Template';
const formCssSelector = window.outerWidth < 990 ? '.large-up-hide form.search' : '.header__search-desktop form.search'

console.log(inputCssSelector)
console.log(formCssSelector)

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector,
    formCssSelector,
    contentCssSelector: "main#MainContent",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    // serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: !location.pathname.includes('/search'),
    serpQuery: {
        products: {
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "thumbUrl",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            // ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            // facets: ["*"]
        }
    },
    compressUrlParameters: true,
    // // Uncomment for Category Merchandising
    
    /* https://nostosolutions.atlassian.net/browse/FEA-11337?focusedCommentId=377589 */
    categoryCssSelector: '.nosto-category',
    
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(() => {
    const nativeInput = document.querySelector(inputCssSelector);
    const nativeSearchIconDesktop = document.querySelector(".header__search-desktop form.search .search__button");
    const nativeSearchIconMobile = document.querySelector(".large-up-hide form.search .search__button");
    
    nativeInput?.addEventListener('keydown', (event) => {
        if (event.key === "Enter" || event.key === 'Escape') closeSearchOverlay();
    });

    nativeSearchIconMobile?.addEventListener('click', closeSearchOverlay);
    nativeSearchIconDesktop?.addEventListener('click', closeSearchOverlay);

    document.querySelector(window.outerWidth < 990
        ? '.header__search .large-up-hide summary'
        : '.header__search-desktop summary'
    )?.addEventListener('click', (e) => {
        if(!nativeInput) return;
        nativeInput.focus();
        nativeInput.click();
    })
})
